const createParamsObject = (params: Array<string>, t) => {
  const finalParams = {};

  if (!params || params.length === 0) {
    return null;
  }

  params.forEach((paramName, index) => {
    finalParams[`param${index}`] = t(`errors.objectKeys.${paramName}`);
  });

  return finalParams;
};

const createGeneralMessage = (error, t, i18n, defaultErrorMessageKey) => {
  let newMessage = '';
  const messageParams = createParamsObject(error?.errors?.general?.params, t);

  if (
    error?.errors?.general?.key &&
    error?.errors?.general?.key !== '' &&
    i18n.exists(`errors.${error?.errors?.general?.key}`)
  ) {
    // Message has key and the key exists in the translation file
    newMessage = t(`errors.${error?.errors?.general?.key}`, messageParams);
  } else if (error?.errors?.general?.message && error?.errors?.general?.message !== '') {
    // Key doesn't exist, use default message of response
    newMessage = error?.errors?.general?.message;
  } else {
    // No default message in response, use default generic message
    newMessage = t(defaultErrorMessageKey);
  }

  return newMessage;
};

const createFieldsMessage = (error, t, i18n) => {
  let newMessage: string[] = [];

  if (!error?.errors?.fields) {
    return '';
  }

  Object.keys(error?.errors?.fields).forEach((field) => {
    const currentField = error?.errors?.fields[field];

    currentField.forEach((fieldError) => {
      const messageParams = createParamsObject(fieldError.params, t);
      if (i18n.exists(`errors.${fieldError.key}`)) {
        newMessage = newMessage.concat(t(`errors.${fieldError.key}`, messageParams));
      } else {
        newMessage = newMessage.concat(fieldError.message);
      }
    });
  });

  return newMessage.join(' ');
};

const createErrorMessage = (error, t, i18n, defaultErrorMessageKey) => {
  let message = [];

  message = message.concat(
    createGeneralMessage(error, t, i18n, defaultErrorMessageKey),
    createFieldsMessage(error, t, i18n)
  );

  return message.join(' ');
};

export default createErrorMessage;
